import { useXcoreCore } from "@robe/client";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";

interface usePdfCdnProps {
  id: number;
  contentLocales: string[];
  type: "product" | "news";
}

export const usePdfCdn = ({ contentLocales, id, type }: usePdfCdnProps) => {
  const { locale } = useRouter();
  const core = useXcoreCore();

  const [origin, setOrigin] = useState<string | null>(null);

  const resolvedLocale = locale ? (contentLocales.includes(locale) ? locale : core.locales[locale].fallbackContentLocale) : null;

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.origin) {
      setOrigin(window.location.origin);
    }
  }, []);

  if (!origin || !resolvedLocale) {
    return null;
  }

  return `${origin}/api/robe/pdfs/${resolvedLocale}/${type}/${id}`;
};
